import React from "react";
import { Table as SemanticTable } from "semantic-ui-react";
import TableHeader from "../TableHeader";
import TableBody from "../TableBody";

const Table = (props) => {
  return (
    <SemanticTable>
      <TableHeader header={props.header} />
      <TableBody body={props.body} />
    </SemanticTable>
  );
};

export default Table;
